<template>
  <section class="lm-row">
    <slot :gutter="gutter"></slot>
  </section>
</template>

<style scoped lang="scss">
.lm-row {
  display: flex;
  justify-content: center;
}
.lm-row::after {
  display: block;
  content: "";
  clear: both;
}
</style>

<script>
export default {
  props: {
    'xs-gutter': {
      type: Number,
      require: true
    },
    'sm-gutter': {
      type: Number,
      require: true
    },
    'md-gutter': {
      type: Number,
      require: true
    },
    'lg-gutter': {
      type: Number,
      require: true
    },
  },
  computed: {
    gutter() {
      return this['md-gutter']
    }
  }
}
</script>